import { useQuery } from "@tanstack/react-query";

import { EcosystemParams, getEcosystem } from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for the ecosystem around a centre.
 *
 * The caller builds the request and says whether it has a centre to read.
 * An unknown centre fails with a 404, which is not retried.
 */
export function useEcosystem(params: EcosystemParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.ecosystem(params),
    queryFn: () => getEcosystem(params),
    enabled,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    retry: (count, error) =>
      (error as { response?: { status?: number } } | null)?.response?.status !==
        404 && count < 2,
  });
}
